import React, { ReactNode } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

import { WithResourceIcon, WithResourceIconProps } from './ResourceTypes';

export interface StackedCellProps {
  upper: ReactNode;
  lower: ReactNode;
  upperTooltip?: ReactNode;
  lowerTooltip?: ReactNode;
  tooltip?: ReactNode;
  showUpperTooltip?: boolean;
  showLowerTooltip?: boolean;
  styles?: { upper?: Record<string, any>; lower?: Record<string, any> };
  iconProps?: Omit<WithResourceIconProps, 'children'>;
}

export const StackedCell = (props: StackedCellProps) => {
  const {
    upper,
    lower,
    lowerTooltip,
    upperTooltip,
    showLowerTooltip = true,
    showUpperTooltip = true,
    tooltip,
    styles,
    iconProps,
  } = props;

  const commonStyles = {
    w: 'full',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  };

  const upperTooltipValue =
    upperTooltip ?? (upper === '-' ? 'Unknown' : upper) ?? '-';
  const lowerTooltipValue =
    lowerTooltip ?? (lower === '-' ? 'Unknown' : lower) ?? '-';

  const renderContent = () => (
    <Stack spacing={0} {...commonStyles}>
      {!!upper && upper !== '-' && showUpperTooltip && !tooltip ? (
        <CustomTooltip label={upperTooltipValue}>
          <Box color="#000" {...commonStyles} {...styles?.upper}>
            {upper}
          </Box>
        </CustomTooltip>
      ) : (
        <Box color="#000" {...commonStyles} {...styles?.upper}>
          {upper ?? '-'}
        </Box>
      )}
      {!!lower && lower !== '-' && showLowerTooltip && !tooltip ? (
        <CustomTooltip label={lowerTooltipValue}>
          <Box
            color={customTheme.colors.gray['250']}
            fontSize="15px"
            {...commonStyles}
            {...styles?.lower}
          >
            {lower}
          </Box>
        </CustomTooltip>
      ) : (
        <Box
          color={customTheme.colors.gray['250']}
          fontSize="15px"
          {...commonStyles}
          {...styles?.lower}
        >
          {lower ?? '-'}
        </Box>
      )}
    </Stack>
  );

  return tooltip ? (
    <CustomTooltip label={tooltip}>{renderContent()}</CustomTooltip>
  ) : iconProps ? (
    <WithResourceIcon {...iconProps}>{renderContent()}</WithResourceIcon>
  ) : (
    renderContent()
  );
};
